//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO PD-300793: Clean up after GA
export const getIsTikTokPhotoPostingEnabled = createHasFeatureSelector(
  FeatureNames.TiktokPhotoPosting,
);
